import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
const filter = require('lodash/filter');
const find = require('lodash/find');
const uuid = require('uuid');
const Moment = require('moment');

const Globals = require('../../../../app/globals');
const StringUtil = require('../../../../app/shared/StringUtil');
const ServerRequest = require('../../actions/request');
const UriUtil = require('../../util/UriUtil');
import Navigator from '../../Navigator';
const SignInStore = require('../../stores/SignInStore');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');
import ErrorBox from '../common/ErrorBox';
import WarningBox from '../common/WarningBox';
import SuccessBox from '../common/SuccessBox';
import LoadingSpinner from '../loading/LoadingSpinner';

import MainNav from '../DashboardNew/Menu/MainNav';

const propTypes = {
    history: PropTypes.object.isRequired,
};

const defaultProps = {

};

class IndividualSelectSubsciptionView extends React.Component {
    constructor(props) {
        super(props);

        const planStoreState = this.getStateFromPlanStoreState(SubscriptionPlanStore.getState());

        this.state = {
            signInStoreState: SignInStore.getState(),
            updating_plan: false,
            planChangeSuccess: false,
            subscribe_error: null,
            subscribe_warning: null,
            upgradeActionId: null,
            ...planStoreState
        };

        this.getStateFromPlanStoreState = this.getStateFromPlanStoreState.bind(this);

        this.unsubscribes = [
            SignInStore.listen(this.onSignInStoreChange.bind(this)),
            SubscriptionPlanStore.listen(this.onSubscriptionPlanStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        SubscriptionPlanActions.getUpgradePlans();
        SubscriptionPlanActions.getSubscriptionPlan();
        SubscriptionPlanActions.getProrateData();
        
        const queryObj = UriUtil.parseLocationSearchString(window.location);
        if (queryObj.update) {
            if (queryObj.update === 'success') {
                if (!this.state.planChangeSuccess) {
                    this.setState({planChangeSuccess:true});
                }
            }
            else if (queryObj.update === 'cancel') {
                if (!this.state.subscribe_warning) {
                    this.setState({
                        subscribe_warning: {
                            message: 'Transaction cancelled'
                        }
                    });
                }
            }
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());

//        if (this.handlerCleanup) {
//            this.handlerCleanup();
//            delete this.handlerCleanup;
//        }
    }

    onSignInStoreChange(newState) {
        this.setState({ signInStoreState: newState });
    }

    onSubscriptionPlanStoreChange(newState) {
        const planStoreState = this.getStateFromPlanStoreState(newState);

        let additionalState = {};
        const action = newState.action;
        if (action.id === this.state.upgradeActionId) {
            if (!action.error) {
                if (action.sessionId) {
                    console.log("stripe embedded mode not supported"); // This shouldn't happen (but leaving this hook here in case we want to use embedded mode)
                    this.setState({
                        subscribe_warning: {
                            message: 'Transaction cancelled'
                        }
                    });
                    
                /* if we were using embedded instead of hosted checkout:
                    this.checkoutPromise = stripe.initEmbeddedCheckout({
                        clientSecret: 'CLIENT_SECRET',
                    });
                    return checkoutPromise.then((checkout)=>{
                        console.log("embedded checkout result",checkout);
                    });
                */
                }
                else if (action.sessionUrl) {
                    // hosted mode when we can't redirect from the server due to CORS
                    console.log("redirecting for session"); // FIXME: remove debug spam
                    window.location.href = action.sessionUrl;
                }
                else {
                    additionalState = { ...additionalState, upgradeActionId: null, planChangeSuccess: true, subscribe_error: null, subscribe_warning: null, updating_plan: false };
                }
            }
            else {
                additionalState = { ...additionalState, upgradeActionId: null, subscribe_error: action.error, updating_plan: false };
            }
        }

        this.setState({ ...planStoreState, ...additionalState });
    }

    getStateFromPlanStoreState(state) {
        console.log('getStateFromPlanStoreState:', state);

        var user_plans = filter(state.upgrade_plans, plan => {
            return Globals.users.is_user_account_type(plan.account_type) && ( plan.process_type === Globals.ecommerce.process_types.CC);
        });

        return {
            user_plans: user_plans,
            plan_prorate_data: state.plan_prorate_data,
            subscription_plan: state.subscription_plan
        };
    }

    handleChangeSubscriptionPromise=(plan_id,proration_date)=>{
        const currentPath = window.location.pathname;
        let success_url = `${GlobalConfig.ApiUrl}${currentPath}?update=success`;
        let cancel_url = `${GlobalConfig.ApiUrl}${currentPath}?update=cancel`;

        const upgradeActionId = uuid.v4();
        this.setState({ upgradeActionId, updating_plan: true },()=>{
            return SubscriptionPlanActions.changeSubscriptionPlan(upgradeActionId, {
                plan_id,
                proration_date, // possibly no longer needed
                success_url,cancel_url,
            });
        });
    }

    doChangePlan=(planId, e)=>{
        e.stopPropagation();
        // const self = this;

        const selectedPlan = find(this.state.user_plans, {id: planId});
        if (!selectedPlan) {
            this.setState({
                subscribe_error: {
                    message: 'Error looking up selected plan!'
                }
            });
            return;
        }

        let cost;
        let proration_date;
        let description;

        const prorateData = this.state.plan_prorate_data[this.state.signInStoreState.userInfo.id];

        if (!!this.state.subscription_plan.subscription && this.state.subscription_plan.subscription.plan_id) { // has existing subscription
            const planProrateData = find(prorateData, planProrateData => {
                return parseInt(planProrateData.id, 10) === parseInt(this.state.subscription_plan.subscription.plan_id, 10);
            });

            if (!!planProrateData) {
                cost = planProrateData.upgrade_cost ? planProrateData.upgrade_cost + selectedPlan.cost : selectedPlan.cost;
                proration_date = planProrateData.proration_date;
                console.log(`planProrateData:`,planProrateData); // FIXME: remove debug spam
            }
            description = `Switch to ${selectedPlan.display_name}`;
        }
        else {
            cost = selectedPlan.cost;
            description = `Subscribe to ${selectedPlan.display_name}`;
        }
        this.handleChangeSubscriptionPromise(selectedPlan.id, proration_date)
    } // doChangePlan

    doRenewPlan=(planId, e)=>{
        e.stopPropagation();
        const self = this;

        const selectedPlan = find(this.state.user_plans, {id: planId});
        if (!selectedPlan) {
            this.setState({
                subscribe_error: {
                    message: 'Error looking up selected plan!'
                }
            });
            return;
        }


        const currentPlan = this.state.subscription_plan.plan;
        const currentSub = this.state.subscription_plan.subscription;

        if (!currentPlan || !currentSub) {
            this.setState({
                subscribe_error: {
                    message: 'Error looking up current plan!'
                }
            });
            return;
        }

        switch (currentPlan.subscription_status) {
            case Globals.ecommerce.subscription_statuses.canceled:
                break;
            case Globals.ecommerce.subscription_statuses.past_due:
            case Globals.ecommerce.subscription_statuses.unpaid:
            case Globals.ecommerce.subscription_statuses.trialing:
            case Globals.ecommerce.subscription_statuses.active:
            default:
                this.setState({
                    subscribe_error: {
                        message: `Cannot rewnew plan with status ${currentPlan.subscription_status}`
                    }
                });
                return;
        }

        let cost;
        let proration_date;
        const currentEndDate = Moment(currentSub.ending_at).format('MMMM D, YYYY')
        const prorateData = this.state.plan_prorate_data[this.state.signInStoreState.userInfo.id];
        const planProrateData = find(prorateData, planProrateData => {
            return parseInt(planProrateData.id, 10) === parseInt(currentSub.plan_id, 10);
        });

        if (!!planProrateData) {
            proration_date = planProrateData.proration_date;
        }
        this.handleChangeSubscriptionPromise(selectedPlan.id, proration_date)
    } // doRenewPlan

    render() {
        if (!this.state.signInStoreState.initialized) {
            return null;
        }

        const individualPlans = this.state.user_plans.filter(plan => plan.account_type === Globals.users.account_types.INDIVIDUAL);
        const havePlan = !!this.state.subscription_plan.subscription && !!this.state.subscription_plan.plan;
        let canPurchase = true;
        let isCanceled = false;
        let isExpired = false;
        let currentSub = null;
        if (havePlan) {
            const currentPlan = this.state.subscription_plan.plan;
            currentSub = this.state.subscription_plan.subscription;

            switch (currentPlan.subscription_status) {
                case Globals.ecommerce.subscription_statuses.past_due:
                case Globals.ecommerce.subscription_statuses.unpaid:
                case Globals.ecommerce.subscription_statuses.trialing:
                case Globals.ecommerce.subscription_statuses.active:
                    canPurchase = false;
                    isCanceled = false;
                    break;
                case Globals.ecommerce.subscription_statuses.canceled:
                    canPurchase = true;
                    isCanceled = true;
                    isExpired = Moment(currentSub.ending_at).isBefore(Moment());
                    break;
                default:
                    console.warn(`Unknown plan type: ${this.state.subscription_plan.plan.subscription_status}`);
            }
        }

        return (
            <div className="view-wrapper">
                { this.state.updating_plan ?
                    <div className="full-screen-blocker text-centered">
                        <LoadingSpinner className="font-size-15rem rel-centered-v" />
                    </div>
                    :
                    null
                }

                <MainNav onClickBrandLogo={() => Navigator.goToDashboardHome(this.props.history)}/>

                <div className="container-fluid">
                    <ErrorBox error={this.state.subscribe_error} />
                    { this.state.subscribe_warning ?
                        <WarningBox>{this.state.subscribe_warning}</WarningBox>
                        :
                        null
                    }


                    { this.state.planChangeSuccess ?
                        <SuccessBox className="margin-top-lg">Your license has been updated.</SuccessBox>
                        :
                        null
                    }

                    <Row>
                        <div className="tile-dash-floating margin-top-lg margin-bottom-lg col-10 offset-1">
                            <h1 className="font-size-xl text-centered">{StringUtil.getStingForAccountType(Globals.users.account_types.INDIVIDUAL)} License</h1>
                            <hr/>
                            <p className="margin-bottom-15">
                                Upgrade to a {StringUtil.getStingForAccountType(Globals.users.account_types.INDIVIDUAL)} License to gain access to features that will allow you to assign your activities to your students and track their progress. A {StringUtil.getStingForAccountType(Globals.users.account_types.INDIVIDUAL)} License includes:
                            </p>
                            <ul className="benefit-list">
                                <li>Unlimited Activities</li>
                                <li>Unlimited Collaborators</li>
                                <li>Unlimited Sharing</li>
                                <li>Local Assignment Support (both ad hoc and group support)</li>
                                <li>View student results</li>
                                <li>Export student results to a .csv</li>
                                <li>Detailed usage analytics</li>
                                <li>Knowledge Base Support</li>
                                <li>License for personal use only</li>

                                {/*
                                <li>Create an deliver assignments to your students</li>
                                <li>View and export student results</li>
                                */}
                            </ul>
                        </div>
                    </Row>

                    <ul className="subBlockList">
                        {   individualPlans.map(plan => {
                                return (
                                    <li key={plan.id} className="subBlock">
                                        {/*<h3 className="subBlock__header">{plan.display_name}</h3>*/}
                                        <div className="subBlock__body">
                                            <ul className="margin-bottom-lg">
                                                <li><span className="font-size-xl">{StringUtil.formatUSD(plan.cost)}</span> / {plan.interval}</li>
                                            </ul>

                                            <div>
                                                { havePlan && currentSub.plan_id === parseInt(plan.id, 10) ?
                                                    <div className="text-left">
                                                        <ul className="statusList">
                                                            <li className="statusList__item--good">You own this license.</li>
                                                            <li className="statusList__item--good">This license is active through {Moment(currentSub.ending_at).format('MMMM D, YYYY')}.</li>
                                                        { !isCanceled ?
                                                            <li className="statusList__item--good">This license will renew.</li>
                                                            :
                                                            <li className="statusList__item--warn">You've cancelled renewal of this license.</li>
                                                        }
                                                        </ul>
                                                        { isCanceled ?
                                                            <div className="subBlock__buttonRow">
                                                                <Button
                                                                    onClick={(e)=>{ this.doRenewPlan(plan.id,e) } }
                                                                >
                                                                    Renew
                                                                </Button>
                                                            </div>
                                                            :
                                                            null
                                                        }
                                                        {(isCanceled && !isExpired) ?
                                                            <div>Renewing will keep your license active and restart billing on {Moment(currentSub.ending_at).format('MMMM D, YYYY')}.</div>
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                    :
                                                    <div className="subBlock__buttonRow">
                                                        <Button
                                                            disabled={this.updating_plan}
                                                            onClick={(e)=>{this.doChangePlan(plan.id,e)}}
                                                        >
                                                            Buy Now
                                                        </Button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

IndividualSelectSubsciptionView.propTypes = propTypes;
IndividualSelectSubsciptionView.defaultProps = defaultProps;

export default withRouter(IndividualSelectSubsciptionView);
